import {jwtDecode} from 'jwt-decode';

export const isTokenValid = () =>{
    console.log('Token validation is invoked');
    const token  = localStorage.getItem("authToken");;

    if(!token){
        console.log('token failed',token);
        return {isAuthenticated:false,role:null};
    }

    try{
        const decode = jwtDecode(token);
        // to convert seconds into miliseconds we do * 1000
        const expirationTime = decode.exp * 1000;
        
        if(expirationTime < Date.now()){
            console.log('Token expied');
            localStorage.removeItem('authToken');
            console.log('token expired')
        return {isAuthenticated:false,role:null};
        }
        console.log('token passed ');
        // console.log(decode);
        return {isAuthenticated:true,user:decode};

    }catch(err){
        console.log('token failed')
        console.log('invalid token');
        return {isAuthenticated:false,role:null};

    }
    
}